import React, { ReactNode } from 'react'



const NotificationStatusAuthorization: React.FC<{
    allowedStatus: string[]
    notificationStatus: string
    children: JSX.Element
}> = ({ allowedStatus, notificationStatus, children }) => {
    const hasRole = (): boolean => {
        return allowedStatus.includes(notificationStatus)
    }

    return hasRole() ? children : null
}

export default NotificationStatusAuthorization
